const state = {
  templates: {
    data: [],
  },
  template: {
    id: '',
    organization_id: '',
    name: '',
    tag: '',
    consultations: [],
    created_at: '',
    updated_at: '',
    endpoints: [],
  },
  availableConsultations: [],
  documents: [],
};

export default state;
